import { render, staticRenderFns } from "./FeedEditor.vue?vue&type=template&id=2acca41e&scoped=true&"
import script from "./FeedEditor.vue?vue&type=script&lang=js&"
export * from "./FeedEditor.vue?vue&type=script&lang=js&"
import style0 from "./FeedEditor.vue?vue&type=style&index=0&id=2acca41e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acca41e",
  null
  
)

export default component.exports